import Header from '@/components/feature/Header';
import Hero from '@/components/feature/Hero';
import AppSection from '@/pages/home/components/AppSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CardsSection from '@/pages/home/components/CardsSection';
import IndexSection from '@/pages/home/components/IndexSection';
import MediaSection from '@/pages/home/components/MediaSection';
import ContactSection from '@/pages/home/components/ContactSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import AboutSection from '@/pages/home/components/AboutSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <AppSection />
        <FaqSection />
        <CardsSection />
        <IndexSection />
        <MediaSection />
        <ContactSection />
        <FeaturesSection />
        <UpdatesSection />
        <AboutSection />
        <TopicsSection />
        <CommentsSection />
        <RankingSection />
        <CarouselSection />
      </main>
      <Footer />
    </div>
  );
}